<template>
    <div class="recipes--search">
        <form id="recipes--search" @submit.prevent="setFilterFromQueryString">
            <input
                class="recipes-search--field"
                type="search"
                name="search"
                placeholder="Sök rätt, ingredienser eller kosttyp"
                autocomplete="off"
                v-model="query"
            />
            <svg class="icon icon-search">
                <use xlink:href="#icon-search"></use>
            </svg>
            <button type="button" class="recipes--search-submit" @click="setFilterFromQueryString">
                Sök
            </button>
        </form>
    </div>
</template>

<script>
import state from './../state.js';

export default {
    data() {
        return {
            state,
            query: ''
        };
    },

    computed: {
        filterState: function () {
            return this.state.filter.search;
        }
    },

    watch: {
        filterState(search) {
            this.query = search ? search : '';
        }
    },

    methods: {
        setFilterFromQueryString() {
            this.state.recipeQueryString = $('form').serialize();
        }
    }
};
</script>
